<template>
    <v-container>
        <h1 class="page-title">User and domain administration</h1>
        <v-tabs
          v-model="tab"
          background-color="secondary"
          dark
        >
          <v-tab :key="'Domains'">Domains</v-tab>
          <v-tab :key="'Users'">Users</v-tab>
          </v-tabs>
        <v-tabs-items v-model="tab">

          <v-tab-item>
            <DomainsTable />
          </v-tab-item>

          <v-tab-item>
            <UsersTable />
          </v-tab-item>

        </v-tabs-items>
    </v-container>

</template>

<script>
    import DomainsTable from '../components/Admin/DomainsTable';
    import UsersTable from '../components/Admin/UsersTable';
    export default {
        name: "UsersAdmin",
        components: {
          DomainsTable,
          UsersTable,
        },
        data: () => ({
            tab: 1,
        }),
        computed: {
        },
        methods: {
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>
